/**
 * SVG icon for relationship aspect
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function SymbolRelationshipBig({ hoveredAspect }) {
  return (
    <symbol
      className="wheel-icon"
      id="icon-relationship"
      viewBox="0 0 139.6 123.2"
    >
      <g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:60',
              'no-hover': true,
              st0: true,
            })}
            d="M114.4,24.2c-6.4-5.2-13-7.4-19.5-6.6c-6.6,0.8-13,4.8-17.6,10.8c-1.5,2.1-4,3.3-6.6,3.3c0,0,0,0,0,0 c-2.6,0-5-1.2-6.6-3.3c-1.2-1.5-9.6-12-21.7-12c-3.7,0-7.6,1-11.8,3.4c-7.3,4.2-11.8,9.7-13.5,16.1c-2,7.6,0.4,15.5,2.5,18.9 c4.8,8.1,32.1,33,51.3,49.5c18-14.9,43.5-38.1,48.5-48.8C125.7,42.2,124.1,32,114.4,24.2z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:60',
              st1: true,
            })}
            d="M65.7,114.8c-8.3-7.4-45.5-41.6-53.2-53.2c-3.7-5.5-10.7-20-2-38.1C20.8,2,46.8,0.3,46.8,0.3v0 c-7.5-0.9-15.8,0.3-24.4,5.4C11.3,12.1,4,21.1,1.3,31.8C-2,44.3,1.5,56.6,5.5,63.2c8.4,14.1,54.7,53.6,59.9,58.1 c1.5,1.3,3.4,1.9,5.3,1.9c1.8,0,3.6-0.6,5.1-1.8c0.6-0.4,1.6-1.3,3.1-2.5C78.9,119,74,122.2,65.7,114.8z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:60',
              st0: true,
              'no-hover': true,
            })}
            d="M44,16.5c-0.5,0-1-0.1-1.5-0.1c-3.7,0-7.6,1-11.8,3.4c-7.3,4.2-11.8,9.7-13.5,16.1c-2,7.6,0.4,15.5,2.5,18.9 c4.8,8.1,32.1,33,51.3,49.5l-8.3-77.9C59.5,23.2,52.8,17.1,44,16.5z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:60',
              st2: true,
            })}
            d="M124.7,11.4C116.4,4.7,107.2,1.1,97.9,1c-1.7,0-3.4,0.1-5,0.3c-8,1-15.8,4.6-22.2,10.2 C64.7,6.3,56.5,1.5,46.8,0.3v0c0,0-26,1.7-36.3,23.2c-8.7,18.1-1.6,32.6,2,38.1c7.7,11.6,44.9,45.8,53.2,53.2 c8.3,7.4,13.2,4.2,13.2,4.1c11.4-9.3,47.3-39.5,55.3-56.4C143.8,42.3,140.4,24.1,124.7,11.4z M127.3,44.5 c-0.5,2.7-3,15.8-14.8,26.7c-11.7,11-41.7,33.1-41.7,33.1C51.7,87.8,24.4,63,19.6,54.8c-2.1-3.5-4.4-11.3-2.5-18.9 c1.7-6.5,6.2-11.9,13.5-16.1c4.2-2.5,8.2-3.4,11.8-3.4c0.5,0,1,0,1.5,0.1c8.9,0.6,15.6,6.7,18.6,10l0,0c0,0,4.2,3.7,8.5,2.7 c4.3-1,8.4-8.9,13.8-12.5c4.7-3.1,16.7-7.3,31.3,2.7C130.8,29.3,127.8,41.9,127.3,44.5z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:60',
              st1: true,
            })}
            d="M116.1,19.3c-14.6-10-26.6-5.8-31.3-2.7c-5.4,3.6-9.5,11.5-13.8,12.5c-4.3,1-8.5-2.7-8.5-2.7l0,0 c0.8,0.9,1.4,1.6,1.6,1.9c1.5,2.1,4,3.3,6.6,3.3c0,0,0,0,0,0c2.6,0,5-1.2,6.6-3.3c4.6-6.1,11-10,17.6-10.8c1.9-0.2,3.7-0.2,5.6,0 c4.7,0.6,9.4,2.8,14,6.5c9.7,7.8,11.3,18.1,5,31.4c-5.1,10.7-30.5,34-48.5,48.8c0,0,29.9-22.1,41.7-33.1 c11.7-11,14.2-24.1,14.8-26.7C127.8,41.9,130.8,29.3,116.1,19.3z"
          />
        </g>
      </g>
    </symbol>
  );
}

SymbolRelationshipBig.propTypes = {
  hoveredAspect: PropTypes.string,
};

export default SymbolRelationshipBig;



// WEBPACK FOOTER //
// js/src/wheel/symbols/SymbolRelationshipBig.js